module.exports = __webpack_public_path__ + "media/images/top/icon/blue/ico_book-09fd0e0f4cd3f37b6998526926d546dc.svg";